export default "__VITE_ASSET__DDa9o7qH__"